// extracted by mini-css-extract-plugin
module.exports = {"container":"AdditionalText_container__1VrcM","description":"AdditionalText_description__3IcEa"};